import { z } from 'zod';

export const updateCalendarViewFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  color: z.string().min(1, 'Color is required'),
});

export type UpdateCalendarViewFormValues = z.infer<typeof updateCalendarViewFormSchema>;
